import { createContext, useContext, useMemo, useState } from 'react'
import type { ReactNode } from 'react'

interface ProjectStore {
  activeProjectId?: string
  setActiveProjectId: (id?: string) => void
}

const ProjectStoreContext = createContext<ProjectStore | undefined>(undefined)

export const ProjectStoreProvider = ({ children }: { children: ReactNode }) => {
  const [activeProjectId, setActiveProjectId] = useState<string | undefined>(undefined)
  const value = useMemo(() => ({ activeProjectId, setActiveProjectId }), [activeProjectId])

  return <ProjectStoreContext.Provider value={value}>{children}</ProjectStoreContext.Provider>
}

export const useProjectStore = () => {
  const context = useContext(ProjectStoreContext)
  if (!context) {
    throw new Error('useProjectStore must be used within ProjectStoreProvider')
  }

  return context
}
